import axios from "axios";
import constants from "../../utils/constants";

const baseURL = constants.BACKEND;

const sendEmail = (request) => {
    return axios
        .post(`${baseURL}api/sendMail`, request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*'
                }
            }
        );
};

const sendEmailAttachment = (request) => {
    return axios
        .post(`${baseURL}api/sendMailAttachment`, request,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': '*/*'
                }
            }
        );
};

const EmailService = {
    sendEmail,
    sendEmailAttachment,
};

export default EmailService;


